import Assessments from './Assessments';

export default Assessments;
